import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { cn } from '../../../lib/utils';
import { RootState } from '../../../reducers';
import { useIsMobile } from '../../../hooks/use-mobile';
import UpgradeButton from './UpgradeButton';
import UpsellButton from './UpsellButton';
import EducationalDiscount from './EducationalDiscount';
import AssistantToolbar from '../../assistant';
import { SidebarTrigger } from '../../../components/ui/sidebar';

export const CustomToolbar: React.FC = () => {
  const open = useSelector(
    (state: RootState) => state.dashboard.drawerState === 'open',
  );
  const isMobile = useIsMobile();
  const [isAssistantFocused, setIsAssistantFocused] = useState(false);

  // Determine if we should hide sidebar button
  const shouldHideSidebarButton = isMobile && isAssistantFocused;

  // Show hamburger when on mobile and sidebar is not open
  const shouldShowHamburger = isMobile && !open && !shouldHideSidebarButton;

  return (
    <header className={cn('sticky top-0 w-full bg-background z-40', 'mb-2')}>
      <div className="flex h-14 items-center px-1 sm:px-2">
        <div
          className={cn(
            'flex w-full items-center justify-between gap-2',
            shouldShowHamburger ? 'pl-0.5' : 'pl-2',
            'pr-1',
          )}
        >
          {/* Hamburger menu - show only when sidebar is in offcanvas mode and closed */}
          {shouldShowHamburger && (
            <SidebarTrigger icon="menu" className="h-10 w-10 p-0" />
          )}

          {/* Assistant Toolbar - takes up available space */}
          <div className="flex-1 min-w-0">
            <AssistantToolbar onFocusChange={setIsAssistantFocused} />
          </div>

          {/* Action Buttons - right aligned with consistent spacing */}
          <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
            <UpsellButton />
            <EducationalDiscount />
            <UpgradeButton />
          </div>
        </div>
      </div>
    </header>
  );
};

export default CustomToolbar;
